import { DataTableSortableColumn, ColumnDef } from '@ui/components';
import { InvoiceRecipientDto } from '@interfaces/models';
import { useTranslation } from 'react-i18next';

export const useInvoiceRecipientsTableColumns = (): ColumnDef<InvoiceRecipientDto>[] => {
  const { t } = useTranslation();

  return [
    {
      accessorKey: 'email',
      header: ({ column }) => {
        return (
          <DataTableSortableColumn
            label={t('FILES_REPORTS.INVOICING.RECIPIENTS_TABLE.EMAIL')}
            column={column}
          />
        );
      },
    },
  ];
};
